// extracted by mini-css-extract-plugin
module.exports = {"rootDiv":"seeItInAction_rootDiv__nrvuf","subtitleDiv":"seeItInAction_subtitleDiv__wxg0L"};